/**
 * Build a hierarchical tree structure from flat file list
 * @param {Array} files - Flat array of file objects with path property
 * @returns {Array} - Hierarchical tree structure
 */
export const buildFileTree = (files) => {
  if (!files || files.length === 0) return [];

  const root = [];

  files.forEach((file) => {
    const parts = file.path.split('/');
    let currentLevel = root;
    let currentPath = '';

    parts.forEach((part, index) => {
      if (currentPath) {
        currentPath += '/' + part;
      } else {
        currentPath = part;
      }
      
      const isLeaf = index === parts.length - 1;
      let existingPath = currentLevel.find(v => v.name === part);

      if (!existingPath) {
        existingPath = {
          path: currentPath,
          name: part,
          children: [],
          type: isLeaf ? file.type : 'tree',
          fileRef: isLeaf ? file.fileRef : null
        };
        currentLevel.push(existingPath);
      }
      currentLevel = existingPath.children;
    });
  });

  return root;
};
